// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.schema-container {
  /* padding: 20px; */
  /* max-width: 1200px; */
  margin: 0 auto;
  width: 90%;
}

.editor-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.editor-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  height: calc(100vh - 190px);
  width: 100%;
  position: relative;
  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
}

.line-numbers {
  background: #f8f9fa;
  padding: 15px 10px;
  border-right: 1px solid #dee2e6;
  color: #6c757d;
  font-size: 14px;
  text-align: right;
  overflow-y: hidden;
  -webkit-user-select: none;
          user-select: none;
}

.line-number {
  padding: 0 10px;
  line-height: 1.5;
  /* font-size: 12px; */
}

.notepad-editor {
  flex: 1 1;
  padding: 15px;
  font-size: 14px;
  line-height: 1.5;
  border: none;
  resize: none;
  background: white;
  color: #333;
  outline: none;
  white-space: pre;
  overflow-y: auto;
  tab-size: 4;
}

.notepad-editor:focus {
  outline: none;
}

.editor-actions {
  display: flex;
  gap: 10px;
}

.btn-outline-secondary {
  color: #6c757d;
  border-color: #6c757d;
}

.btn-outline-secondary:hover {
  color: white;
  background-color: #6c757d;
}

.save-notification {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: #28c76f;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  opacity: 0;
  transition: opacity 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Scrollbar styling */
.notepad-editor::-webkit-scrollbar {
  width: 8px;
}

.notepad-editor::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.notepad-editor::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.notepad-editor::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Placeholder styling */
.notepad-editor::placeholder {
  color: #adb5bd;
}

.add-entry-form {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.entries-list {
  margin-top: 20px;
}

.entry-card {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 15px;
  transition: all 0.3s ease;
}

.entry-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.entry-content {
  margin-bottom: 15px;
}

.entry-content p {
  margin: 5px 0;
  padding: 8px;
  background-color: #f8f9fa;
  border-radius: 4px;
}

.entry-content strong {
  display: block;
  margin-bottom: 5px;
  color: #495057;
}

.entry-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

.input-group {
  margin-bottom: 15px;
}

.form-control:focus {
  border-color: #7367f0;
  box-shadow: 0 0 0 0.2rem rgba(115, 103, 240, 0.25);
}

textarea.form-control {
  resize: vertical;
  min-height: 100px;
}

.btn-primary {
  background-color: #7367f0;
  border-color: #7367f0;
}

.btn-primary:hover {
  background-color: #5e50ee;
  border-color: #5e50ee;
}

.btn-success {
  background-color: #28c76f;
  border-color: #28c76f;
}

.btn-success:hover {
  background-color: #24b263;
  border-color: #24b263;
}

.btn-danger {
  background-color: #ea5455;
  border-color: #ea5455;
}

.btn-danger:hover {
  background-color: #e42728;
  border-color: #e42728;
}`, "",{"version":3,"sources":["webpack://./src/admin/screens/ai/schema.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,2BAA2B;EAC3B,WAAW;EACX,kBAAkB;EAClB,2DAA2D;AAC7D;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,6BAA6B;EAC7B,wCAAwC;AAC1C;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kDAAkD;AACpD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB","sourcesContent":[".schema-container {\n  /* padding: 20px; */\n  /* max-width: 1200px; */\n  margin: 0 auto;\n  width: 90%;\n}\n\n.editor-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.editor-container {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  display: flex;\n  height: calc(100vh - 190px);\n  width: 100%;\n  position: relative;\n  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;\n}\n\n.line-numbers {\n  background: #f8f9fa;\n  padding: 15px 10px;\n  border-right: 1px solid #dee2e6;\n  color: #6c757d;\n  font-size: 14px;\n  text-align: right;\n  overflow-y: hidden;\n  user-select: none;\n}\n\n.line-number {\n  padding: 0 10px;\n  line-height: 1.5;\n  /* font-size: 12px; */\n}\n\n.notepad-editor {\n  flex: 1;\n  padding: 15px;\n  font-size: 14px;\n  line-height: 1.5;\n  border: none;\n  resize: none;\n  background: white;\n  color: #333;\n  outline: none;\n  white-space: pre;\n  overflow-y: auto;\n  tab-size: 4;\n}\n\n.notepad-editor:focus {\n  outline: none;\n}\n\n.editor-actions {\n  display: flex;\n  gap: 10px;\n}\n\n.btn-outline-secondary {\n  color: #6c757d;\n  border-color: #6c757d;\n}\n\n.btn-outline-secondary:hover {\n  color: white;\n  background-color: #6c757d;\n}\n\n.save-notification {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  background-color: #28c76f;\n  color: white;\n  padding: 10px 20px;\n  border-radius: 4px;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n/* Scrollbar styling */\n.notepad-editor::-webkit-scrollbar {\n  width: 8px;\n}\n\n.notepad-editor::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n.notepad-editor::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 4px;\n}\n\n.notepad-editor::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8;\n}\n\n/* Placeholder styling */\n.notepad-editor::placeholder {\n  color: #adb5bd;\n}\n\n.add-entry-form {\n  background-color: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.entries-list {\n  margin-top: 20px;\n}\n\n.entry-card {\n  background-color: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  margin-bottom: 15px;\n  transition: all 0.3s ease;\n}\n\n.entry-card:hover {\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.entry-content {\n  margin-bottom: 15px;\n}\n\n.entry-content p {\n  margin: 5px 0;\n  padding: 8px;\n  background-color: #f8f9fa;\n  border-radius: 4px;\n}\n\n.entry-content strong {\n  display: block;\n  margin-bottom: 5px;\n  color: #495057;\n}\n\n.entry-actions {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n}\n\n.input-group {\n  margin-bottom: 15px;\n}\n\n.form-control:focus {\n  border-color: #7367f0;\n  box-shadow: 0 0 0 0.2rem rgba(115, 103, 240, 0.25);\n}\n\ntextarea.form-control {\n  resize: vertical;\n  min-height: 100px;\n}\n\n.btn-primary {\n  background-color: #7367f0;\n  border-color: #7367f0;\n}\n\n.btn-primary:hover {\n  background-color: #5e50ee;\n  border-color: #5e50ee;\n}\n\n.btn-success {\n  background-color: #28c76f;\n  border-color: #28c76f;\n}\n\n.btn-success:hover {\n  background-color: #24b263;\n  border-color: #24b263;\n}\n\n.btn-danger {\n  background-color: #ea5455;\n  border-color: #ea5455;\n}\n\n.btn-danger:hover {\n  background-color: #e42728;\n  border-color: #e42728;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
